<template>
    <div>

        <!-- Status -->
        <div class="row">
            <div class="col-12" :class="{ 'col-md-6 mb-10 md:mb-0' : (isFullRack || isHalfRackLockable) }">
                <sau-service-status :service="service"></sau-service-status>
            </div>
            <template v-if="isFullRack || isHalfRackLockable">
                <div class="col-12 col-md-6">
                    <div class="sau-bx bx-pad text-center h-100 flex flex-col align-center justify-center">
                        <sau-spinner v-if="loadingLatestPowerRecord">
                            <template #message>Loading power data</template>
                        </sau-spinner>
                        <template v-else>
                            <template v-if="latestPowerRecord">
                                <h4>Power Usage: <span class="text-success">{{ latestPowerRecord.kva }} kVA</span></h4>
                                <p>Recorded on {{latestPowerRecord.record_date}}</p>
                                <a :href="powerLink" class="btn btn-success sau-font-bold" title="View detailed power usage">View Usage</a>
                            </template>
                            <template v-else>
                                <h4>Power Usage: {{ latestPowerError || 'Not Available' }}</h4>
                                <p>We were unable to retrieve the power usage for this rack.</p>
                            </template>
                        </template>
                    </div>
                </div>
            </template>
        </div>

        <!-- Access Request -->
        <div class="row pt-12" v-if="display">
            <div class="col">
                <div class="sau-bx bx-pad text-center">
                    <img src="/img/illustrations/colocation.svg" width="200" />
                    <h4>Need physical access to your colocation server?</h4>
                    <p>You'll need to submit an access request ticket. One of our team members will respond shortly.</p>
                    <a :href="accessRequestLink" class="sau-link-button sm">Request access</a>
                </div>
            </div>
        </div>

        <!-- Bandwidth -->
        <sau-bandwidth-graph  v-if="showBandwidth && checked" class="pt-12" :service="service"></sau-bandwidth-graph>
    </div>
</template>

<script>
import axios from 'axios';

export default {
    props:['service'],

    data() {
        return {
            display: false,
            loadingLatestPowerRecord: false,
            latestPowerRecord: null,
            latestPowerError: null,
        }
    },

    created() {
        // Lock down functionality if the service is suspended
        if(this.service.status.toLowerCase() != 'suspended') {
            this.display = true;
        }

        if(this.isFullRack || this.isHalfRackLockable) {
            this.getLatestPowerRecord();
        }
    },

    mounted() {
        // if(this.isFullRack) {
        //     this.getLatestPowerRecord();
        // }
    },

    methods: {
        getLatestPowerRecord() {
            this.loadingLatestPowerRecord = true;
            axios.get(`/api/services/colocation/${this.service.id}/power/latest`).then((response) => {
                this.latestPowerRecord = response.data;
            }).catch(() => {
                this.latestPowerError = 'Not Available';
            }).finally(() => {
                this.loadingLatestPowerRecord = false;
            });
        }
    },

    computed: {
        accessRequestLink() {
            return `/access/${this.service.id}`;
        },

        powerLink() {
            return `/service/colocation/${this.service.id}/allocation#power-usage`;
        },

        isFullRack() {
            return _.get(this.service, 'custom.Rack Space', '').toLowerCase().includes('full rack');
        },

        isHalfRackLockable() {
            return _.get(this.service, 'custom.Rack Space', '').toLowerCase().includes('half rack lockable');
        }
        
    }
}
</script>

<style>
</style>
